var map = {
	"./01-eurovision/eurovision-01.webp": 7249,
	"./01-eurovision/eurovision-02.webp": 5667,
	"./01-eurovision/eurovision-03.webp": 430,
	"./01-eurovision/eurovision-04.webp": 4471,
	"./02-mystery-shopper/produsul-alpha-01.webp": 5536,
	"./02-mystery-shopper/produsul-alpha-02.webp": 5116,
	"./02-mystery-shopper/produsul-alpha-03.webp": 5833,
	"./02-mystery-shopper/produsul-alpha-04.webp": 4979,
	"./02-mystery-shopper/produsul-alpha-05.webp": 569,
	"./02-mystery-shopper/produsul-alpha-06.webp": 7727,
	"./03-uk-employment-rate/01-image.webp": 5252,
	"./03-uk-employment-rate/02-image.webp": 6629,
	"./04-burden-of-disease/01-image.webp": 1311,
	"./05-hr-dashboard/01-image.webp": 9894,
	"./06-superstore-sales/01-image.webp": 6473,
	"./06-superstore-sales/02-image.webp": 9548,
	"./07-hollywood-profitable-films/01-image.webp": 7496,
	"./08-earthquakes/01-image.webp": 491,
	"./08-earthquakes/02-image.webp": 6190,
	"./09-netflix-movies-and-shows/01-image.webp": 1721,
	"./09-netflix-movies-and-shows/02-image.webp": 1934
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 400;